import { Component, Vue } from "vue-facing-decorator";

/**
 * Enum for icon type.
 */
enum IconEnum {
    DEFAULT = 'default',
    RIPPLE = 'ripple',
    DUAL_RING = 'dual-ring',
    SPINNER = 'spinner',
}

@Component
export default class ProcessingMessage extends Vue {
	IconEnum = IconEnum; // Make the enum accessible in the component's scope

	get isBotHasAvatar() {
		return this.$store.state.isBotHasAvatar || false;
	}

	get typingType() {
		return this.$store.state.typingType || 0;
	}

	get isUserHasAvatar() {
		return this.$store.state.isUserHasAvatar || false;
	}

	get processingDisplayIcon() {
		return this.$store.state.processingDisplayIcon || "";
	}

	get processingDisplayText() {
		return this.$store.state.processingDisplayText || "";
	}
}
